module.exports = __webpack_public_path__ + "static/media/ObservationOther.cbda0876.jpg";